import { combineReducers } from "redux";
import products from "../features/admin/products/slice";


const commerce = combineReducers({
    products: products,
});

export default commerce;
